import { User, UserParams } from 'models/User'

export type MovieParams = Readonly<{
    id: string
    user: UserParams
}>

export class Movie implements MovieParams {
    readonly id: string
    readonly user: User

    constructor(params: MovieParams) {
        this.id = params.id
        this.user = User.of(params.user)

        Object.freeze(this)
    }
}
